export const CHECK_PROMOCODE = 'CHECK_PROMOCODE';
export const CLEAR_PROMOCODE = 'CLEAR_PROMOCODE';